//   { subjectId: 1, subjectName: '英语' },
// { subjectId: 2, subjectName: '数学' },
// { subjectId: 3, subjectName: '语文' },
// { subjectId: 4, subjectName: '物理' },
// { subjectId: 5, subjectName: '化学' },
export const subjectMap = {
  1: '英语',
  2: '数学',
  3: '语文',
  4: '物理',
  5: '化学',
};
export const subjectList = [
  { id: 1, name: '英语' },
  { id: 2, name: '数学' },
  { id: 3, name: '语文' },
  { id: 4, name: '物理' },
  { id: 5, name: '化学' },
];
export const scienceSubjectList = [
  { id: 1, name: '英语' },
  { id: 2, name: '数学' },
  { id: 3, name: '语文' },
  { id: 4, name: '物理' },
  { id: 5, name: '化学' },
];
export const en = 1;
export const math = 2;
